import { render, staticRenderFns } from "./CmgRemovePaymentCardModal.vue?vue&type=template&id=bccbbeaa&scoped=true&lang=pug"
import script from "./cmg-remove-payment-card-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-remove-payment-card-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRemovePaymentCardModal.vue?vue&type=style&index=0&id=bccbbeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccbbeaa",
  null
  
)

export default component.exports